module.exports = __webpack_public_path__ + "img/laoniangjiu.1b213229.png";